import * as ResourceApi from 'api/resources';
import {emptyPageFactory} from './factories';

const {Image, Challenge, Prize, User, Campaign, UGCSubmission, StoreCatalog, PrizeboothOrder} = ResourceApi.Types;

export const makeDefaultResourcePages = () => {
    return [Image, Challenge, Prize, User, Campaign, UGCSubmission, StoreCatalog, PrizeboothOrder].reduce((resourcePages, pageName) => {
        resourcePages[pageName] = emptyPageFactory();
        return resourcePages;
    }, {});
};

export const makeDefaultAllResources = () => {
    return ['Image', 'Challenge', 'Prize'].reduce((allResources, resourceType) => {
        allResources[resourceType] = {content: []};
        return allResources;
    }, {});
};

const initialState = {
    resources: {},
    resourcePages: makeDefaultResourcePages(),

    // for cases where we want the contents of all pages for a given resource, but without breaking
    // paging functionality for that resource elsewhere.
    allResources: makeDefaultAllResources(),

    pendingSaves: {},
    saveErrors: {},
    savedField: {}
};

export default initialState;



// WEBPACK FOOTER //
// ./public/resources/initialState.js